import { motion } from "framer-motion";

/**
 * QuickActions — row de chips compactos (icon + label opcional). Wrap em telas
 * pequenas. Cada chip é botão; onClick obrigatório.
 *
 * Props:
 *   actions: [{
 *     label: string,
 *     icon?: ReactNode,           // ícone lucide-react já renderizado
 *     onClick: () => void,
 *     tone?: 'neutral'|'info'|'success' (default neutral)
 *   }]
 */
const TONE = {
  neutral: "border-white/10 hover:bg-white/5 text-slate-300",
  info:    "border-semantic-info/30 hover:bg-semantic-info/10 text-semantic-info",
  success: "border-semantic-success/30 hover:bg-semantic-success/10 text-semantic-success",
};

export default function QuickActions({ actions = [] }) {
  if (!actions.length) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 2 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="flex flex-wrap items-center gap-1.5"
      data-testid="ds-quick-actions"
    >
      {actions.map((action, idx) => {
        const tone = TONE[action.tone] || TONE.neutral;
        return (
          <button
            key={action.label + idx}
            type="button"
            onClick={action.onClick}
            className={`inline-flex items-center gap-1.5 text-[12px] px-2.5 py-1 rounded-full border bg-transparent transition-colors ${tone}`}
            data-testid="ds-quick-action-chip"
          >
            {action.icon}
            <span>{action.label}</span>
          </button>
        );
      })}
    </motion.div>
  );
}
